import { createAction, props } from '@ngrx/store';
import { DeviceGroup } from '../../../api/models/device-group.model';
import { SceneStatus } from '../../../api/models/scene-status.model';
import { ScheduleSummary } from '../../../api/models/schedule-summary.model';
import { Update } from '@ngrx/entity';

export const loadScenesStatus = createAction(
    '[Scenes Status] Load Scenes status via service',
    props<{ locationId: number }>()
);

export const loadScenesStatusSuccess = createAction(
    '[Scenes Status] Load Scenes status success',
    props<{ ScenesStatus: SceneStatus[] }>()
)

export const loadScenesStatusFail = createAction(
    '[Scenes Status] Load Scenes status failed',
    props<{ error: any }>()
)

export const startPollingScenesStatus = createAction(
    '[Scenes Status] Start Polling',
)

export const stopPollingScenesStatus = createAction(
    '[Scenes Status] Stop Polling',
)

export const clear = createAction(
    '[Scenes Status] Clear all Scenes statuses'
);
export const scenesStatusActions = {
    loadScenesStatus,
    loadScenesStatusSuccess,
    loadScenesStatusFail,
    startPollingScenesStatus,
    stopPollingScenesStatus,
    clear
}
